import { observable, action } from 'mobx';
import { ArrayApp, Model, App } from 'core/index';
import { SocialAccountEditor } from 'legacyComponents/layout/socialStats';

export class SocialAccountModel extends Model {
  static registryName = 'SocialAccountModel';
  @observable accountType;
  @observable accountName;
}

export class SocialAccountApp extends App {
  static registryName = 'SocialAccountApp';
  static Model = SocialAccountModel;
}

export class SocialAccountsApp extends ArrayApp {
  static registryName = 'SocialAccountsApp';
  static ElementApp = SocialAccountApp;
  @observable accountEditor = null;
  @action StartEditAccount = (account, accType) => {
    this.accountEditor = new SocialAccountEditor(this, account, accType);
  };

  @action StopEditAccount = () => {
    this.accountEditor = null;
  };

  @action Add = (accountType, accountName) => {
    this.push(new SocialAccountApp(this, { accountType, accountName }));
    this.accountEditor = null;
  };

  @action Delete = account => {
    if (account.id === undefined) {
      this.remove(account);
    } else {
      account.deleted = true;
    }
  };
}
